import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as types from '../../constants/actionTypes';
import StatusLegend from '../Common/StatusLegend/StatusLegend';
import GraphArc from '../Common/GraphArc/GraphArc';
import Card from '../Common/Card';
import Notification from '../Common/Notification';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';

export class ProjectOverview extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isLoadingAllTasksGraph: true,
            isLoadingMilestoneTaskGraph: true,
            isLoadingCoachTasks: true,
            isLoadingCertifiedTasks: true,
            allTasksGraph: {},
            milestoneTasksGraph: {},
            coachTasks: {},
            certifiedTasks: {}
        }
    }

    componentDidMount = () => {
        this.loadAllProjectTasksGraph();
        this.loadProjectMilestoneTasksGraph();
        this.loadProjectCoachTasksGraph();
        this.loadProjectCertifiedTasksGraph();
    }

    componentDidUpdate(prevProps) {
        // reload the summary when the user changes locations
        // they could be searching for a location so make sure there is a value
        if ((this.props.projectKey && this.props.projectKey !== prevProps.projectKey)) {
            this.setState({
                isLoadingCoachTasks: true,
                isLoadingAllTasksGraph: true,
                isLoadingMilestoneTaskGraph: true,
                isLoadingCertifiedTasks: true,
            }, () => {
                this.loadAllProjectTasksGraph();
                this.loadProjectMilestoneTasksGraph();
                this.loadProjectCoachTasksGraph();
                this.loadProjectCertifiedTasksGraph();       
            })
        }
    }

    loadAllProjectTasksGraph = async () => {
        // the user could be searching for a location and not have one selected yet
        if (this.props.projectKey === "") { return; }
        try {
            const response = await this.props.projectMgrDashboardActions.loadAllProjectTasksGraph(this.props.projectKey);
            if (response.type === types.LOAD_PROJECT_ALL_TASKS_GRAPH_SUCCESS) {

                this.setState({
                    allTasksGraph: response.payload.allProjectTasks
                })

            } else if (response.type === types.LOAD_PROJECT_ALL_TASKS_GRAPH_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoadingAllTasksGraph: false });
        }
    }

    loadProjectMilestoneTasksGraph = async () => {
        // the user could be searching for a location and not have one selected yet
        if (this.props.projectKey === "") { return; }
        try {
            const response = await this.props.projectMgrDashboardActions.loadProjectMilestoneTasksGraph(this.props.projectKey);
            if (response.type === types.LOAD_PROJECT_MILESTONE_TASKS_GRAPH_SUCCESS) {

                this.setState({
                    milestoneTasksGraph: response.payload.projectMilestoneTasks
                })

            } else if (response.type === types.LOAD_PROJECT_MILESTONE_TASKS_GRAPH_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoadingMilestoneTaskGraph: false });
        }
    }

    loadProjectCoachTasksGraph = async () => {
        // the user could be searching for a location and not have one selected yet
        if (this.props.projectKey === "") { return; }
        try {
            const response = await this.props.projectMgrDashboardActions.loadProjectCoachTasksGraph(this.props.projectKey);
            if (response.type === types.LOAD_PROJECT_COACH_TASKS_GRAPH_SUCCESS) {

                this.setState({
                    coachTasks: response.payload.coachTasks
                })

            } else if (response.type === types.LOAD_PROJECT_COACH_TASKS_GRAPH_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoadingCoachTasks: false });
        }
    }

    loadProjectCertifiedTasksGraph = async () => {
        // the user could be searching for a location and not have one selected yet
        if (this.props.projectKey === "") { return; }
        try {
            const response = await this.props.projectMgrDashboardActions.loadProjectCertifiedTasksGraph(this.props.projectKey);
            if (response.type === types.LOAD_PROJECT_CERTIFIED_TASKS_GRAPH_SUCCESS) {

                this.setState({
                    certifiedTasks: response.payload.certifiedTasks
                })

            } else if (response.type === types.LOAD_PROJECT_CERTIFIED_TASKS_GRAPH_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoadingCertifiedTasks: false });
        }
    }

    onClick_DoNothing = () => {
        return null;
    }

    render() {
        
        return (
            <div className='summary-widget'>
                <div className="row">
                    <div className="col-12">
                        <div className="dashboard-widget-title">Overview</div>
                        <div className="float-end">
                            <StatusLegend />
                        </div>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-md-3 col-sm-6 quarter-card mb-3">
                        <LoadingIndicator isLoading={this.state.isLoadingAllTasksGraph}>
                            <Card>
                                <Fragment>
                                    { this.state.isLoadingAllTasksGraph === false &&
                                        <GraphArc title="All Tasks" 
                                            data={this.state.allTasksGraph.data}
                                            totalUrlParams={this.state.allTasksGraph.totalUrlParams}
                                            onClick={this.onClick_DoNothing}
                                        />                                
                                    }                                    
                                </Fragment>
                            </Card>                            
                        </LoadingIndicator>
                    </div>
                    <div className="col-md-3 col-sm-6 quarter-card mb-3">
                        <LoadingIndicator isLoading={this.state.isLoadingMilestoneTaskGraph}>
                            <Card>
                                <Fragment>
                                    { this.state.isLoadingMilestoneTaskGraph === false &&
                                        <GraphArc title="Milestone Tasks" 
                                            data={this.state.milestoneTasksGraph.data}
                                            totalUrlParams={this.state.milestoneTasksGraph.totalUrlParams}
                                            onClick={this.onClick_DoNothing}
                                        />                                
                                    }                                    
                                </Fragment>
                            </Card>                            
                        </LoadingIndicator>
                    </div>
                    <div className="col-md-3 col-sm-6 quarter-card mb-3">
                        <LoadingIndicator isLoading={this.state.isLoadingCoachTasks}>
                            <Card>
                                <Fragment>
                                    { this.state.isLoadingCoachTasks === false &&
                                        <GraphArc title="Coach Assigned" 
                                            data={this.state.coachTasks.data}
                                            totalUrlParams={this.state.coachTasks.totalUrlParams}
                                            onClick={this.onClick_DoNothing}
                                        />                                
                                    }                                    
                                </Fragment>
                            </Card>                            
                        </LoadingIndicator>
                    </div>
                    <div className="col-md-3 col-sm-6 quarter-card">
                        <LoadingIndicator isLoading={this.state.isLoadingCertifiedTasks}>
                            <Card>
                                <Fragment>
                                    { this.state.isLoadingCertifiedTasks === false &&
                                        <GraphArc title="Locations Certified" 
                                            data={this.state.certifiedTasks.data}
                                            totalUrlParams={this.state.certifiedTasks.totalUrlParams}
                                            onClick={this.onClick_DoNothing}
                                        />                                
                                    }                                    
                                </Fragment>
                            </Card>                            
                        </LoadingIndicator>
                    </div>
                </div>
            </div>
        )
    }
}

ProjectOverview.propTypes = {
    windowWidth: PropTypes.number.isRequired,
    projectMgrDashboardActions: PropTypes.object.isRequired,
    subscriptionId: PropTypes.string.isRequired,
    user: PropTypes.object,
    projectKey: PropTypes.string // not required - user could be searching for a location
};
function mapStateToProps(state) {
    return {
        user: state.user
    };
}

export default connect(mapStateToProps, null)(ProjectOverview);